<template>
	<div class="fill-height width-100 max-width-100" v-on="$listeners">
		<NativeElementTreeBlockButton class="pointer-events-none" :element="element" v-if="isNative" />
		<TileElementTreeBlockButton class="width-100 pointer-events-none" :element="element" :workflow="workflow" v-else-if="isTile" />
		<UiElementTreeBlockButton
			class="pointer-events-none"
			:hideNoDesignMessage="hideNoDesignMessage"
			:uiElement="element"
			:placement="placement"
			v-else
		/>
	</div>
</template>

<script>
import NativeElementTreeBlockButton from './NativeElementTreeBlockButton.vue';
import UiElementTreeBlockButton from './UiElementTreeBlockButton.vue';
import TileElementTreeBlockButton from './TileElementTreeBlockButton.vue';
import { isTileElement } from '@/utils/element-service';
export default {
	name: 'ElementTreeBlockButton',
	components: {
		NativeElementTreeBlockButton,
		UiElementTreeBlockButton,
		TileElementTreeBlockButton,
	},
	props: {
		element: { type: Object },
		isNative: { type: Boolean },
		hideNoDesignMessage: { type: Boolean },
		placement: { type: Object },
		workflow: { type: Object },
	},
	computed: {
		isTile() {
			return isTileElement(this.element.type);
		},
	},
};
</script>
<style scoped></style>
